import { styled } from '@mui/system'
import { colors, fontSizes, BORDER_RADIUSES, ARTICLE_CARD_SIZE } from '../../../consts'

type CategoryCardProps = {
  backgroundImage: string
}

export const CategoryCard = styled('div')<CategoryCardProps>(
  ({ backgroundImage, theme }) => ({
    position: 'relative',
    width: ARTICLE_CARD_SIZE.videoCategories.desktop,
    aspectRatio: '4 / 5',
    borderRadius: BORDER_RADIUSES.small,
    overflow: 'hidden',
    cursor: 'pointer',
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.02)',
    },
    '&:focus': {
      outline: `2px solid ${colors.black}`,
      outlineOffset: 2,
    },
    [theme.breakpoints.down('md')]: {
      width: ARTICLE_CARD_SIZE.videoCategories.tablet,
    },
    [theme.breakpoints.down('sm')]: {
      width: ARTICLE_CARD_SIZE.videoCategories.mobile,
    },
  })
)

export const CategoryOverlay = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: `linear-gradient(to bottom, ${colors.black}00 0%, ${colors.black}4D 100%)`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  padding: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}))

export const CategoryText = styled('h3')(({ theme }) => ({
  color: colors.white,
  margin: 0,
  fontSize: fontSizes.semiLarge,
  fontWeight: 600,
  textShadow: `0 2px 0 ${colors.black}`,
  lineHeight: 1.2,

  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.medium,
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.medium,
  },
}))

export const CategoryTag = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  left: theme.spacing(2),
  backgroundColor: colors.yellow,
  color: colors.black,
  fontSize: fontSizes.xSmall,
  fontWeight: 600,
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  borderRadius: BORDER_RADIUSES.xSmall,
  textTransform: 'uppercase',
  zIndex: 2,
  boxShadow: `0 2px 4px ${colors.black}40`,

  [theme.breakpoints.down('sm')]: {
    top: theme.spacing(1.5),
    left: theme.spacing(1.5),
    fontSize: fontSizes.xSmall,
    padding: `${theme.spacing(0.4)} ${theme.spacing(0.8)}`,
  },
}))
